import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import ModeEditRoundedIcon from '@mui/icons-material/ModeEditRounded';

import graph from './graph';
import schema from './schema';
import uiSchema from './uiSchema';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery, useMutation } from '@apollo/client';
import { MuiFormBuilder, NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';

export default function UpdatePopup({ ids, label = 'update-coupon', title = 'ویرایش', refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [init, setInit] = useState(formData);
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [updateModel, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          for_admin: 1,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { title, shop, category, amount, start_date, end_date, description } = res;
        if (res) {
          setInit({
            title,
            end_date,
            start_date,
            description,
            shop_id: shop?.id,
            category_id: category?.id,
            amount: Number(amount),
          });
        }
      }
    } catch (error) {}
  };

  const onChange = ({ formData }) => {
    setInit((prev) => ({ ...prev, ...formData }));
  };

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await updateModel({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          ...formData,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.update.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <IconButton size="small" color="secondary" onClick={onOpen} sx={{ bgcolor: 'secondary.lighter' }}>
        <ModeEditRoundedIcon fontSize="small" />
      </IconButton>
      <NewDialog label={label} open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          {loading ? (
            <Stack rowGap={3} py={2} alignItems="center" justifyContent="center" height={140}>
              <CircularProgress />
            </Stack>
          ) : (
            <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
              <MuiFormBuilder
                id={label}
                formData={init}
                onSubmit={onSubmit}
                showSubmit={false}
                liveValidate={false}
                schema={schema()}
                uiSchema={uiSchema(init)}
              />
            </Stack>
          )}
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            form={label}
            type="submit"
            size="medium"
            color="success"
            variant="contained"
            sx={{ minWidth: 80 }}
            disabled={loading || updating}
            endIcon={<DoneRoundedIcon />}
          >
            ثبت
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
